var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-card',[_vm._v("\n    欢迎您, "+_vm._s(_vm.user.username)+"\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }